const updateAssetsDisplayType = (code) => {
  return code.replace(/"([^"]+)":"blob:[^"]+"/g, '"$1":"/assets/$1.png"');
};

export default updateAssetsDisplayType;
